<template>  

<div class="container-fluid mt-2">

  <div class="row">

      <div class="col-12" style="">
        <div class="card border-0">
          <div class="card-header bg-transparent"><h3 class="text-muted">Settings</h3></div>

          
            <nav class="navbar navbar-expand-lg navbar-light bg-transparent mb-0 p-1">
              
              <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
              </button>

              <div class="collapse navbar-collapse" id="navbarSupportedContent">
                <ul class="navbar-nav mr-auto bg-transparent mb-0 pb-1">
                  <li class="nav-item ">
                    <a class="nav-link" href="#" @click="getMainView('settings-account', '', '', '')"><h5 class="m-0 p-0">Account</h5></a>
                  </li>
                  <li class="nav-item ">
                    <a class="nav-link" href="#" @click="getMainView('settings-contact-main', '', '', '')"><h5 class="m-0 p-0">Contacts</h5></a>
                  </li>
                  <li class="nav-item ">
                    <a class="nav-link" href="#" @click="getMainView('settings-organization-main', '', '', '')"><h5 class="m-0 p-0">Organizations</h5></a>
                  </li>
                </ul>
              </div>
            </nav>
            <div class="card-body border-top p-0">
              <transition name="slide-fade" mode="out-in">
                <component 
                  :is="mainView" 
                  :prop1="mvProp1" 
                  :prop2="mvProp2" 
                  :prop3="mvProp3" 
                  @onSComplete="successComplete" 
                  @onUComplete="unsuccessComplete"
                  @onSecondary="secondaryAction"
                >
                </component>
              </transition>
            </div>
        </div>
      </div>


  </div>

</div>


</template>




<script>
import {store} from '../../stores/settings-user-main-store.js'

import settingAccount from '../settingsPageComponents/settings-account-main.vue'


import userSettingContact from '../settingsUserComponents/settingsUserContactComponents/settings-user-contact-main.vue'
import userSettingOrg from '../settingsUserComponents/settingsUserOrgComponents/settings-user-organization-main.vue'


export default {
  store,
  data: function () {
    return { 
      
    }
  },
  computed: {
    mainView () { return this.$store.state.mainView },
    mvProp1 () { return this.$store.state.mvProp1 },
    mvProp2 () { return this.$store.state.mvProp2 },
    mvProp3 () { return this.$store.state.mvProp3 },
  },
  watch: {
    
  },
  mounted() {
    this.getAllUserOrganizations();
    this.getAllUserContacts();
    this.getAllUserDetails();
  },
  methods: {
    getMainView(name, x, y, z) { this.$store.dispatch("getMainView", { name: name, prop1: x, prop2: y, prop3: z })  },
    getAllUserOrganizations() { this.$store.dispatch("getAllUserOrganizations")  },
    getAllUserContacts() { this.$store.dispatch("getAllUserContacts")  },
    getAllUserDetails() { this.$store.dispatch("getAllUserDetails")  },

    successComplete(value) {
      var _this = this;
      switch(value[0]) {
        case 'settings-account':
        _this.getAllUserDetails();
        _this.getMainView('settings-account', '', '', '');
        break;
        default:
      }
    },
    unsuccessComplete(value) {
      var _this = this;
      switch(value[0]) {
        case 'product-builder':
          _this.getMainView('product-main', '', '', '');
        break;
        case 'product-view':
          _this.getMainView('product-main', '', '', '');
        break;
        default:
      }
    },
    secondaryAction(value) {
      var _this = this;
      switch(value[0]) {
        case 'product-view':
        _this.getMainView('product-main', '', '', '');
        break;
        default:
      }
    },

  },    
  components:{
    'settings-account' : settingAccount,


    'settings-contact-main' : userSettingContact,
    'settings-organization-main' : userSettingOrg,

  },
  filters: {

  }
}
</script>
